import type { IModuleDefinition } from '@platform/core/types';
import { mainRecordTypeOf } from '@platform/engine/menu/moduleSections';

/**
 * Лічильник пункту меню «Модель даних» (прототип v4 mdItems: 1 + MOD_ENTITIES[модуль].length): основна сутність і сутності прототипу
 * головного типу (`designEntities` без `extra`); визначення без `designEntities` — кількість неприхованих типів записів. Чиста функція.
 */
export function modelCountOf(module: IModuleDefinition): number {
  const main = mainRecordTypeOf(module);
  if (main?.designEntities) return 1 + main.designEntities.filter((e) => !e.extra).length;
  return module.recordTypes.filter((r) => !r.hidden).length;
}
